/*
 * @Author: 丨小小风离丨
 * @Date: 2024-05-13 20:56:30
 * @LastEditTime: 2024-10-22 20:36:27
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\enrollPlan\list\numericInput.tsx
 * @Description: 
 */
import { Form } from 'antd';
import { LgInput } from 'lancoo-web-ui';
import { useState } from 'react';

interface NumericInputProps {
    form?: any
    extramsg: any
    label: string
    name: string
    min?: number
    max?: number
    isPreview?: boolean
}

const NumericInput = (props: NumericInputProps) => {
    const {
        form,
        extramsg,
        label,
        name,
        min = 0,
        max = 100,
        isPreview = false
    } = props;

    const [inputValue, setInputValue] = useState('');

    const handleChange = (e) => {
        const { value } = e.target;
        const temp = form.getFieldsValue();
        // 允许的输入：空字符串、纯数字、数字开头后跟一个小数点和最多一位数字
        const reg = /^\d*(\.\d?)?$/;
        if (value === '' || reg.test(value)) {
            const numValue = parseFloat(value);
            if (!isNaN(numValue) && (numValue > max || numValue < min)) {
                // 如果用户尝试输入超过范围的值，不更新输入框内容
                form.setFieldsValue({
                    ...temp,
                    [name]: inputValue
                });
                return;
            }
            setInputValue(value);
            form.setFieldsValue({
                ...temp,
                [name]: value
            });
        } else {
            // 不符合条件的输入会被忽略，从而不允许用户输入非数字和多余的小数位
            form.setFieldsValue({
                ...temp,
                [name]: inputValue
            });
        }
    };

    return (
        <>
            {
                extramsg?.basicField?.[name]?.collect ?
                    <Form.Item
                        label={label}
                        name={name}
                        rules={[
                            {
                                required: extramsg?.basicField?.[name]?.need,
                                message: ''
                            },
                            {
                                validator: (_, value) => {
                                    if ((value === undefined || value === '') && extramsg?.basicField?.[name]?.need) {
                                        return Promise.reject(new Error(`${label}不能为空!`));
                                    }
                                    const numValue = parseFloat(value);
                                    if (numValue && (isNaN(numValue) || numValue < min || numValue > max)) {
                                        return Promise.reject(new Error(`${label}必须在${min}到${max}之间`));
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}
                        normalize={value => {
                            return value?.trim?.()
                        }}
                    >
                        {isPreview ? <span>{form.getFieldValue(name) || '--'}</span> :
                            <LgInput
                                placeholder={`请输入${label}`}
                                autoComplete='off'
                                value={form.getFieldValue(name)}
                                onChange={handleChange}
                            />
                        }
                    </Form.Item> : null
            }
        </>
    );
};

export default NumericInput;
